import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ResourceService } from '@teem/generic/resource.service';
import { proposal as ProposalApi } from '@teem/constants/api';
import { Proposal, ProposalSerializer } from '@teem/models/proposal';

@Injectable({
  providedIn: 'root'
})
export class ProposalService extends ResourceService<Proposal> {

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      ProposalApi.endPoint,
      new ProposalSerializer()
    )
  }

  public action(params: any) {
    return this.httpClient.patch(`${ProposalApi.action}`, params);
  }

  public commonData() {
    return this.httpClient.get(`${ProposalApi.common}`, this.httpOptions);
  }
}
